import React from 'react';
import './StatCard.css';

const StatCard = ({ value, label, subtext, source }) => {
  if (!value) return null;

  return (
    <div className="stat-card">
      <div className="stat-card__value">{value}</div>
      {label && <div className="stat-card__label">{label}</div>}
      {subtext && <div className="stat-card__subtext">{subtext}</div>}
      {source && <div className="stat-card__source">Source: {source}</div>}
    </div>
  );
};

export default StatCard;
